import { Product } from '@components/ProductCard';

import { getShafaAbsoluteUrl } from './common';

type ListItem = {
  '@type': string,
  position: number,
  item: {
    '@type': string,
    image: string,
    name: string,
    url: string,
    brand?: {
      '@type': string,
      name: string,
    },
    offers?: {
      '@type': string,
      priceCurrency: string,
      price: number,
      availability: string,
      priceSpecification?: {
        '@type': string,
        priceType: string
        price: number,
        priceCurrency: string,
      }
    },
    itemCondition: string,
    aggregateRating?: {
      '@type': string,
      ratingValue: number,
      bestRating: number,
      worstRating: number,
      ratingCount?: number,
    }
  }
};

export const getCollectionPageStructuredData = (
  metaTitle: string | null | undefined,
  metaDescription: string | null | undefined,
  url: string,
  products: Product[],
) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: metaTitle,
    url: url,
    ...metaDescription && { description: metaDescription },
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: products.map((product, i) => {
        return {
          '@type': 'ListItem',
          position: i,
          url: getShafaAbsoluteUrl(product.url),
          image: product.thumbnail,
          name: product.name,
        };
      }),
    },
  };
};

export const getItemListStructuredData = (
  metaTitle: string | null | undefined,
  url: string,
  productsCount: number,
  products: Product[],
) => {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'ItemList',
        url: url,
        name: metaTitle,
        numberOfItems: productsCount,
        itemListElement: products.map(
          (product, i) => {
            const listItem: ListItem = {
              '@type': 'ListItem',
              position: i + 1,
              item: {
                '@type': 'Product',
                image: product.thumbnail,
                name: product.name,
                url: getShafaAbsoluteUrl(product.url),
                offers: {
                  '@type': 'Offer',
                  priceCurrency: 'UAH',
                  price: product.price || 0,
                  availability: 'https://schema.org/InStock',
                  ...product.oldPrice && {
                    priceSpecification: {
                      '@type': 'UnitPriceSpecification',
                      priceType: 'https://schema.org/ListPrice',
                      price: product.oldPrice,
                      priceCurrency: 'UAH',
                    },
                  },
                },
                itemCondition: product.isNew ? 'https://schema.org/NewCondition' : 'https://schema.org/UsedCondition',
              },
            };
            if (product.brand) {
              listItem.item.brand = {
                '@type': 'Brand',
                name: product.brand.name,
              };
            }
            if (product.rating) {
              listItem.item.aggregateRating = {
                '@type': 'AggregateRating',
                ratingValue: product.rating,
                bestRating: 5,
                worstRating: 1,
                ...product.ratingAmount && { ratingCount: product.ratingAmount },
              };
            }
            return listItem;
          },
        ),
      }],
  };
};
